import { gql } from '@apollo/client';
import { CheckoutBasicFieldsFragment } from '../../fragments/checkout/CheckoutBasicFields.gql';
import { CheckoutUserFieldsFragment } from '../../fragments/checkout/CheckoutUserFields.gql';
import { CheckoutPricingFieldsFragment } from '../../fragments/checkout/CheckoutPricingFields.gql';
import { CheckoutExtendedFieldsFragment } from '../../fragments/checkout/CheckoutExtendedFields.gql';
import { LinesForAnalyticsFieldsFragment } from '../../fragments/checkout/LinesForAnalyticsFields.gql';
import { LinesBasicFieldsFragment } from '../../fragments/checkout/LinesBasicFields.gql';

const CHECKOUT_SHIPPING_ADDRESS_UPDATE_MUTATION = gql`
    ${CheckoutBasicFieldsFragment}
    ${CheckoutUserFieldsFragment}
    ${CheckoutPricingFieldsFragment}
    ${CheckoutExtendedFieldsFragment}
    ${LinesForAnalyticsFieldsFragment}
    ${LinesBasicFieldsFragment}
    mutation CheckoutShippingAddressUpdate(
        $checkout: ID!
        $address: AddressInput
        $shippingAddressId: ID
    ) {
        checkoutShippingAddressUpdate(
            checkoutId: $checkout
            shippingAddress: $address
            shippingAddressId: $shippingAddressId
        ) {
            checkout {
                ...CheckoutBasicFields
                ...CheckoutUserFields
                ...CheckoutPricingFields
                ...CheckoutExtendedFields
                lines {
                    ...LinesBasicFields
                    ...LinesForAnalyticsFields
                }
            }
            errors {
                message
                field
            }
        }
    }
`;

export default CHECKOUT_SHIPPING_ADDRESS_UPDATE_MUTATION;
